import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { serverURL, postData } from "../../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const BackIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const EditIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
const DocumentIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>);
const EarningsIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>);
const WalletIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 12v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5z"/><path d="M22 12h-6a2 2 0 0 0-2 2 2 2 0 0 0 2 2h6"/><line x1="18" y1="9" x2="18" y2="9.01"/></svg>);
const LocationIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>);
const HistoryIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>);
const OrderIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>);
const PhoneIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>);
const EmailIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>);
const CalendarIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>);
const IdCardIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><circle cx="12" cy="10" r="3"/><path d="M7 15c0-2 3-3 5-3s5 1 5 3"/></svg>);
const ImageIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>);
const CameraIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>);
const CheckCircleIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>);
const EyeIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>);
const EyeOffIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>);

// ─────────────────────────────────────────────────────────────────────────────
// DELIVERY HISTORY TABLE COMPONENT - Updated with organisation_name
// ─────────────────────────────────────────────────────────────────────────────
const DeliveryHistoryTable = ({ driverId, isDark }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;

  const colors = {
    background: isDark ? "#0d1117" : "#f9fafb",
    surface: isDark ? "#141824" : "#ffffff",
    border: isDark ? "#1e2740" : "#e5e7eb",
    borderLight: isDark ? "#1e2740" : "#f3f4f6",
    textPrimary: isDark ? "#f1f5f9" : "#111827",
    textSecondary: isDark ? "#94a3b8" : "#6b7280",
    textMuted: isDark ? "#64748b" : "#9ca3af",
    inputBg: isDark ? "#141824" : "#f9fafb",
  };

  useEffect(() => {
    if (driverId) {
      fetchDeliveryHistory();
    }
  }, [driverId, currentPage]);

  const fetchDeliveryHistory = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await postData("drivers/Ridersorderhistory", {
        delivery_person_id: driverId
      });
      console.log("Delivery History Response:", response);

      if (response?.status === true && Array.isArray(response?.data)) {
        setOrders(response.data);
        setTotalPages(Math.ceil(response.data.length / itemsPerPage));
      } else {
        setOrders([]);
        setError("No delivery history found");
      }
    } catch (err) {
      console.error("Error fetching delivery history:", err);
      setError("Failed to load delivery history");
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return d.toLocaleDateString('en-IN', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatCurrency = (amount) => {
    if (!amount) return "₹0";
    return `₹${parseFloat(amount).toFixed(2)}`;
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      delivered: { bg: "rgba(16,185,129,0.15)", color: "#10b981", label: "Delivered" },
      completed: { bg: "rgba(16,185,129,0.15)", color: "#10b981", label: "Completed" },
      pending: { bg: "rgba(245,158,11,0.15)", color: "#f59e0b", label: "Pending" },
      placed: { bg: "rgba(59,130,246,0.15)", color: "#3b82f6", label: "Placed" },
      accepted: { bg: "rgba(139,92,246,0.15)", color: "#8b5cf6", label: "Accepted" },
      processing: { bg: "rgba(59,130,246,0.15)", color: "#3b82f6", label: "Processing" },
      cancelled: { bg: "rgba(239,68,68,0.15)", color: "#ef4444", label: "Cancelled" },
      confirmed: { bg: "rgba(139,92,246,0.15)", color: "#8b5cf6", label: "Confirmed" },
      shipped: { bg: "rgba(6,182,212,0.15)", color: "#06b6d4", label: "Shipped" },
      out_for_delivery: { bg: "rgba(6,182,212,0.15)", color: "#06b6d4", label: "Out for Delivery" },
      ready: { bg: "rgba(236,72,153,0.15)", color: "#ec4899", label: "Ready" },
      preparing: { bg: "rgba(168,85,247,0.15)", color: "#a855f7", label: "Preparing" },
      dropped: { bg: "rgba(107,114,128,0.15)", color: "#6b7280", label: "Dropped" }
    };
    const s = statusMap[status?.toLowerCase()] || { bg: "rgba(107,114,128,0.12)", color: "#6b7280", label: status || "Unknown" };
    return (
      <span style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: "12px",
        fontSize: "11px",
        fontWeight: 600,
        background: s.bg,
        color: s.color
      }}>
        {s.label}
      </span>
    );
  };

  const getPayStatusBadge = (status) => {
    const isPaid = status?.toLowerCase() === "paid";
    return (
      <span style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: "12px",
        fontSize: "10px",
        fontWeight: 600,
        background: isPaid ? "rgba(16,185,129,0.15)" : "rgba(245,158,11,0.15)",
        color: isPaid ? "#10b981" : "#f59e0b"
      }}>
        {isPaid ? "Paid" : "Pending"}
      </span>
    );
  };

  const paginatedOrders = orders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  if (loading) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        padding: "40px",
        color: colors.textMuted
      }}>
        <div style={{ 
          width: "30px", 
          height: "30px", 
          border: `3px solid ${colors.border}`, 
          borderTopColor: "#3b82f6", 
          borderRadius: "50%", 
          animation: "spin 1s linear infinite",
          marginRight: "12px"
        }} />
        Loading delivery history...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        textAlign: "center", 
        padding: "40px",
        color: colors.textMuted
      }}>
        <div style={{ fontSize: "48px", marginBottom: "12px" }}>📦</div>
        <p style={{ color: colors.textSecondary }}>{error}</p>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div style={{ 
        textAlign: "center", 
        padding: "60px 20px",
        background: colors.surface,
        borderRadius: "16px",
        border: `1px solid ${colors.border}`
      }}>
        <div style={{ fontSize: "48px", marginBottom: "12px" }}>🚚</div>
        <h3 style={{ color: colors.textPrimary, marginBottom: "8px" }}>No Deliveries Yet</h3>
        <p style={{ color: colors.textMuted }}>This driver hasn't completed any deliveries</p>
      </div>
    );
  }

  return (
    <div style={{
      background: colors.surface,
      border: `1px solid ${colors.border}`,
      borderRadius: "16px",
      overflow: "hidden"
    }}>
      <div style={{
        padding: "16px 20px",
        borderBottom: `1px solid ${colors.border}`,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "12px",
        background: isDark ? "#0f1520" : "#f8fafc"
      }}>
        <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: colors.textPrimary }}>
          📋 Delivery History
        </h3>
        <span style={{ fontSize: "12px", color: colors.textMuted }}>
          Total Deliveries: <strong style={{ color: colors.textPrimary }}>{orders.length}</strong>
        </span>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{
          width: "100%",
          borderCollapse: "collapse",
          minWidth: "900px",
          fontSize: "13px"
        }}>
          <thead>
            <tr style={{
              background: isDark ? "#0f1520" : "#f8fafc",
              borderBottom: `1px solid ${colors.border}`
            }}>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>Order ID</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>User</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>Restaurant</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>Amount</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>Payment</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>Restro Status</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>Driver Status</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "11px", fontWeight: 700, color: "#3b82f6" }}>Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedOrders.map((order, idx) => (
              <tr
                key={order.id || idx}
                style={{
                  borderBottom: idx < paginatedOrders.length - 1 ? `1px solid ${colors.borderLight}` : "none",
                  transition: "background 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.01)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
              >
                <td style={{ padding: "12px 16px", fontWeight: 600, fontFamily: "monospace", color: "#3b82f6", fontSize: "12px" }}>
                  #{order.id}
                </td>
                <td style={{ padding: "12px 16px", color: colors.textSecondary }}>
                  {order.receiver_name || `User ${order.userid}`}
                </td>
                <td style={{ padding: "12px 16px", color: colors.textSecondary }}>
                  {/* ✅ UPDATED: Show organisation_name if available, fallback to designation */}
                  {order.organisation_name || order.designation || "N/A"}
                </td>
                <td style={{ padding: "12px 16px", fontWeight: 600, color: "#10b981" }}>
                  {formatCurrency(order.final_amount || order.price)}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  {getPayStatusBadge(order.pay_status)}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  {getStatusBadge(order.order_status_restro)}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  {getStatusBadge(order.order_status_driver)}
                </td>
                <td style={{ padding: "12px 16px", fontSize: "11px", color: colors.textMuted }}>
                  {formatDateTime(order.created_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{
          padding: "12px 20px",
          borderTop: `1px solid ${colors.border}`,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
          background: isDark ? "#0f1520" : "#f8fafc"
        }}>
          <span style={{ fontSize: "12px", color: colors.textMuted }}>
            Showing {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, orders.length)} of {orders.length} deliveries
          </span>
          <div style={{ display: "flex", gap: "6px" }}>
            <button
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              style={{
                padding: "6px 12px",
                borderRadius: "6px",
                border: `1px solid ${colors.border}`,
                background: colors.surface,
                color: currentPage === 1 ? colors.textMuted : colors.textPrimary,
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                fontSize: "12px",
                transition: "all 0.2s"
              }}
            >
              Previous
            </button>
            <span style={{
              padding: "6px 12px",
              borderRadius: "6px",
              background: "#3b82f6",
              color: "#fff",
              fontSize: "12px",
              fontWeight: 600
            }}>
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              disabled={currentPage === totalPages}
              style={{
                padding: "6px 12px",
                borderRadius: "6px",
                border: `1px solid ${colors.border}`,
                background: colors.surface,
                color: currentPage === totalPages ? colors.textMuted : colors.textPrimary,
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                fontSize: "12px",
                transition: "all 0.2s"
              }}
            >
              Next
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// IMAGE COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────
const DriverDocumentImage = ({ picName, label, theme, size = "80px" }) => {
  const [imageError, setImageError] = useState(false);
  
  const getCleanFilename = (picPath) => {
    if (!picPath || picPath.trim() === "" || picPath === "NULL" || picPath === "null") return null;
    if (picPath.includes('/')) {
      return picPath.split('/').pop();
    }
    return picPath;
  };
  
  const filename = getCleanFilename(picName);
  const imageUrl = filename ? `${serverURL}/public/uploadnew/upload/${filename}` : null;
  
  if (!imageUrl || imageError) {
    return (
      <div style={{ 
        width: size, 
        height: size, 
        borderRadius: "12px", 
        background: theme === 'dark' ? "#1a2035" : "#f3f4f6",
        display: "flex", 
        flexDirection: "column",
        alignItems: "center", 
        justifyContent: "center",
        border: `1px solid ${theme === 'dark' ? "#2a3145" : "#e5e7eb"}`
      }}>
        <CameraIcon style={{ color: "#64748b", width: "24px", height: "24px" }} />
        <span style={{ fontSize: "9px", color: "#64748b", marginTop: "4px" }}>No Image</span>
      </div>
    );
  }
  
  return (
    <img
      src={imageUrl}
      alt={label}
      onError={() => setImageError(true)}
      style={{
        width: size,
        height: size,
        borderRadius: "12px",
        objectFit: "cover",
        border: `1px solid ${theme === 'dark' ? "#2a3145" : "#e5e7eb"}`
      }}
    />
  );
};

const DriverAvatar = ({ picName, name, theme, size = "80px" }) => {
  const [imageError, setImageError] = useState(false);
  
  const getCleanFilename = (picPath) => {
    if (!picPath || picPath.trim() === "" || picPath === "NULL" || picPath === "null") return null;
    if (picPath.includes('/')) {
      return picPath.split('/').pop();
    }
    return picPath;
  };
  
  const filename = getCleanFilename(picName);
  const imageUrl = filename ? `${serverURL}/public/uploadnew/upload/${filename}` : null;
  
  if (!imageUrl || imageError) {
    const initial = name ? name.charAt(0).toUpperCase() : "D";
    return (
      <div style={{ 
        width: size, 
        height: size, 
        borderRadius: "50%", 
        background: `linear-gradient(135deg, #4a6cf7, #8b5cf6)`, 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        fontSize: typeof size === 'string' ? "32px" : `${parseInt(size) * 0.4}px`, 
        fontWeight: 700, 
        color: "#fff" 
      }}>
        {initial}
      </div>
    );
  }
  
  return (
    <img
      src={imageUrl}
      alt={name}
      onError={() => setImageError(true)}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover",
        border: `2px solid ${theme === 'dark' ? "#2a3145" : "#e5e7eb"}`
      }}
    />
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// STATUS BADGES
// ─────────────────────────────────────────────────────────────────────────────
const StatusBadge = ({ status, colors }) => {
  const isActive = status === "Active" || status === "1";
  const displayStatus = isActive ? "Active" : "Inactive";
  const bg = isActive ? "rgba(16,185,129,0.15)" : "rgba(148,163,184,0.12)";
  const color = isActive ? colors.success : colors.textMuted;
  return (
    <span style={{ padding: "4px 12px", borderRadius: "20px", background: bg, color: color, fontSize: "12px", fontWeight: 600 }}>
      {displayStatus}
    </span>
  );
};

const ReadyBadge = ({ is_ready, colors }) => {
  const ready = is_ready === "1" ? "Yes" : "No";
  const bg = ready === "Yes" ? "rgba(16,185,129,0.15)" : "rgba(245,158,11,0.12)";
  const color = ready === "Yes" ? colors.success : colors.warning;
  return (
    <span style={{ padding: "4px 12px", borderRadius: "20px", background: bg, color: color, fontSize: "12px", fontWeight: 600 }}>
      {ready}
    </span>
  );
};

const OnOffBadge = ({ open_status, colors }) => {
  const value = open_status === "1" ? "ON" : "OFF";
  const bg = value === "ON" ? "rgba(34,197,94,0.15)" : "rgba(148,163,184,0.12)";
  const color = value === "ON" ? colors.success : colors.textMuted;
  return (
    <span style={{ padding: "4px 12px", borderRadius: "20px", background: bg, color: color, fontSize: "12px", fontWeight: 700 }}>
      {value}
    </span>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// VERIFICATION STATUS COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const VerificationStatusCard = ({ label, isVerified, remarks, colors }) => {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "12px 16px",
      borderBottom: `1px solid ${colors.borderLight}`,
      flexWrap: "wrap",
      gap: "8px"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <span style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          background: isVerified ? "rgba(16,185,129,0.15)" : "rgba(245,158,11,0.15)",
          color: isVerified ? "#10b981" : "#f59e0b"
        }}>
          {isVerified ? "✅" : "⏳"}
        </span>
        <span style={{ fontSize: "13px", fontWeight: 500, color: colors.textSecondary }}>
          {label}
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <span style={{
          fontSize: "12px",
          fontWeight: 600,
          color: isVerified ? colors.success : colors.warning
        }}>
          {isVerified ? "Verified" : "Pending"}
        </span>
        {remarks && (
          <span style={{
            fontSize: "11px",
            color: colors.textMuted,
            background: colors.inputBg,
            padding: "2px 10px",
            borderRadius: "12px"
          }}>
            {remarks}
          </span>
        )}
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// PASSWORD FIELD COMPONENT WITH SHOW/HIDE
// ─────────────────────────────────────────────────────────────────────────────
const PasswordField = ({ password, colors }) => {
  const [showPassword, setShowPassword] = useState(false);

  if (!password) {
    return <span style={{ color: colors.textMuted, fontSize: "13px" }}>Not set</span>;
  }

  return (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      gap: "12px",
      width: "100%"
    }}>
      <span style={{ 
        fontSize: "13px", 
        color: colors.textPrimary,
        fontFamily: "monospace",
        letterSpacing: showPassword ? "0px" : "2px"
      }}>
        {showPassword ? password : "••••••••"}
      </span>
      <button
        onClick={() => setShowPassword(!showPassword)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          color: colors.textMuted,
          display: "flex",
          alignItems: "center",
          padding: "4px",
          borderRadius: "4px",
          transition: "all 0.2s"
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = colors.surfaceLighter}
        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      >
        {showPassword ? <EyeOffIcon /> : <EyeIcon />}
      </button>
      <span style={{ 
        fontSize: "10px", 
        color: colors.textMuted,
        cursor: "pointer"
      }}>
        {showPassword ? "Hide" : "Show"}
      </span>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT - Driver Details Page
// ─────────────────────────────────────────────────────────────────────────────
const DriverDetails = ({ isDark = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [driver, setDriver] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");

  const colors = {
    background: isDark ? "#0d1117" : "#f9fafb",
    surface: isDark ? "#141824" : "#ffffff",
    border: isDark ? "#1e2740" : "#e5e7eb",
    borderLight: isDark ? "#1e2740" : "#f3f4f6",
    textPrimary: isDark ? "#f1f5f9" : "#111827",
    textSecondary: isDark ? "#94a3b8" : "#6b7280",
    textMuted: isDark ? "#64748b" : "#9ca3af",
    inputBg: isDark ? "#141824" : "#f9fafb",
    surfaceLighter: isDark ? "#1a2035" : "#f3f4f6",
    surfaceHover: isDark ? "rgba(255,255,255,0.025)" : "rgba(0,0,0,0.02)",
    inputBorder: isDark ? "#1e2740" : "#e5e7eb",
    selectedBg: isDark ? "rgba(59,130,246,0.07)" : "rgba(79,70,229,0.05)",
    buttonPrimaryBg: isDark ? "#1e3a8a" : "#eef2ff",
    buttonPrimaryColor: isDark ? "#93c5fd" : "#4f46e5",
    modalBg: isDark ? "#141824" : "#ffffff",
    modalBorder: isDark ? "#1e2740" : "#e5e7eb",
    deleteBg: isDark ? "rgba(239,68,68,0.15)" : "#fef2f2",
    deleteColor: "#ef4444",
    primary: "#4a6cf7",
    primaryLight: isDark ? "#1e3a8a" : "#eef2ff",
    success: "#10b981",
    warning: "#f59e0b",
    danger: "#ef4444",
  };

  useEffect(() => {
    const driverData = location.state?.driver;
    if (driverData) {
      setDriver(driverData);
      setLoading(false);
    } else {
      setError("No driver data found");
      setLoading(false);
    }
  }, [location]);

  const handleEdit = () => {
    console.log("✏️ Editing driver with data:", driver);
    navigate("/Dashboard/AddNewDriver", { 
      state: { 
        mode: "edit", 
        driverData: {
          id: driver.id || "",
          old_id: driver.old_id || driver.id || "",
          name: driver.name || "",
          first_name: driver.first_name || "",
          last_name: driver.last_name || "",
          pre: driver.pre || "",
          gender: driver.gender || "",
          contact: driver.contact || driver.primary_number || "",
          primary_number: driver.primary_number || driver.contact || "",
          secondary_number: driver.secondary_number || "",
          whatsapp_number: driver.whatsapp_number || "",
          email: driver.email || "",
          password: driver.password || "",
          address: driver.address || "",
          city: driver.city || "",
          state: driver.state || "",
          postal: driver.postal || "",
          latitude: driver.latitude || "",
          longitude: driver.longitude || "",
          date_of_birth: driver.date_of_birth || "",
          blood_group: driver.blood_group || "",
          bank_name: driver.bank_name || "",
          bank_branch: driver.bank_branch || "",
          bank_type: driver.bank_type || "",
          account_holder: driver.account_holder || "",
          account_number: driver.account_number || "",
          ifsc: driver.ifsc || "",
          bank_mobile: driver.bank_mobile || "",
          upi: driver.upi || "",
          wallet: driver.wallet || "0",
          cash_inhand: driver.cash_inhand || "0",
          status: driver.status || "",
          open_status: driver.open_status || "",
          is_ready: driver.is_ready || "",
          hide: driver.hide || "",
          is_verify_personalinfo: driver.is_verify_personalinfo || "",
          is_verify_docinfo: driver.is_verify_docinfo || "",
          is_verify_vehicle: driver.is_verify_vehicle || "",
          is_verify_bankinfo: driver.is_verify_bankinfo || "",
          is_verify_emergency: driver.is_verify_emergency || "",
          remarks_personalinfo: driver.remarks_personalinfo || "",
          remarks_docinfo: driver.remarks_docinfo || "",
          remarks_vehicle: driver.remarks_vehicle || "",
          remarks_bankinfo: driver.remarks_bankinfo || "",
          remarks_emergency: driver.remarks_emergency || "",
          pic: driver.pic || "",
          aadhar_front: driver.aadhar_front || "",
          aadhar_back: driver.aadhar_back || "",
          pan_card: driver.pan_card || "",
          dl_front: driver.dl_front || "",
          dl_back: driver.dl_back || "",
          rc_front: driver.rc_front || "",
          rc_back: driver.rc_back || "",
          cancel_cheque: driver.cancel_cheque || "",
          bank_pass: driver.bank_pass || "",
          resume: driver.resume || "",
          created_by_id: driver.created_by_id || "",
          designation_id: driver.designation_id || "",
          refer_by: driver.refer_by || "",
          myreferal: driver.myreferal || "",
          subject: driver.subject || "",
          details: driver.details || "",
          created_at: driver.created_at || "",
          updated_at: driver.updated_at || "",
          login_session: driver.login_session || "",
          sessionid: driver.sessionid || "",
          fcm_token: driver.fcm_token || "",
        } 
      } 
    });
  };

  const handleVerifyDocuments = () => {
    setActiveTab("documents");
  };

  const handleViewEarnings = () => {
    navigate("/Dashboard/DriverEarnings", { state: { driver } });
  };

  const handleViewWallet = () => {
    navigate("/Dashboard/DriverWallet", { state: { driver } });
  };

  const handleViewLocation = () => {
    navigate("/Dashboard/DriverLiveLocation", { state: { driver } });
  };

  const handleViewHistory = () => {
    setActiveTab("delivery_history");
  };

  const handleAssignOrder = () => {
    navigate("/Dashboard/AssignOrderToDriver", { state: { driver } });
  };

  const documentImages = [
    { label: "Driver Photo", key: "pic", value: driver?.pic },
    { label: "Aadhar Front", key: "aadhar_front", value: driver?.aadhar_front },
    { label: "Aadhar Back", key: "aadhar_back", value: driver?.aadhar_back },
    { label: "Pan Card", key: "pan_card", value: driver?.pan_card },
    { label: "Driving License Front", key: "dl_front", value: driver?.dl_front },
    { label: "Driving License Back", key: "dl_back", value: driver?.dl_back },
    { label: "RC Front", key: "rc_front", value: driver?.rc_front },
    { label: "RC Back", key: "rc_back", value: driver?.rc_back },
    { label: "Cancel Cheque", key: "cancel_cheque", value: driver?.cancel_cheque },
    { label: "Bank Pass", key: "bank_pass", value: driver?.bank_pass },
    { label: "Resume", key: "resume", value: driver?.resume },
  ].filter(img => img.value && img.value !== "" && img.value !== "NULL" && img.value !== "null");

  const tabs = [
    { id: "overview", label: "Overview", icon: <IdCardIcon />, onClick: () => setActiveTab("overview") },
    { id: "delivery_history", label: "Delivery History", icon: <HistoryIcon />, onClick: handleViewHistory },
    { id: "edit", label: "Edit Driver", icon: <EditIcon />, onClick: handleEdit },
    { id: "documents", label: "Verify Documents", icon: <DocumentIcon />, onClick: handleVerifyDocuments },
    // { id: "earnings", label: "Earnings", icon: <EarningsIcon />, onClick: handleViewEarnings },
    // { id: "wallet", label: "Wallet", icon: <WalletIcon />, onClick: handleViewWallet },
    // { id: "location", label: "Live Location", icon: <LocationIcon />, onClick: handleViewLocation },
    // { id: "assign", label: "Assign Order", icon: <OrderIcon />, onClick: handleAssignOrder },
  ];

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", background: colors.background, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ width: "40px", height: "40px", border: `3px solid ${colors.border}`, borderTopColor: colors.primary, borderRadius: "50%", animation: "spin 1s linear infinite", margin: "0 auto 16px" }} />
          <p style={{ color: colors.textSecondary }}>Loading driver details...</p>
        </div>
      </div>
    );
  }

  if (error || !driver) {
    return (
      <div style={{ minHeight: "100vh", background: colors.background, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <p style={{ color: colors.danger, marginBottom: "16px" }}>{error || "Driver not found"}</p>
          <button onClick={() => navigate(-1)} style={{ padding: "10px 20px", background: colors.primary, border: "none", borderRadius: "8px", color: "#fff", cursor: "pointer" }}>Go Back</button>
        </div>
      </div>
    );
  }

  const displayName = driver.name || `${driver.first_name || ''} ${driver.last_name || ''}`.trim() || `Driver ${driver.id}`;
  const displayContact = driver.contact || driver.primary_number || driver.whatsapp_number || 'N/A';
  const displayEmail = driver.email || '—';
  const displayWallet = `₹${parseFloat(driver.wallet || 0).toLocaleString()}`;
  const displayCashInHand = driver.cash_inhand ? `₹${parseFloat(driver.cash_inhand).toLocaleString()}` : '₹0';
  const joinedDate = driver.created_at ? new Date(driver.created_at).toLocaleString() : driver.rd || 'N/A';

  const styles = {
    container: { minHeight: "100vh", background: colors.background, fontFamily: "'Inter', sans-serif" },
    header: { 
      background: colors.surface, 
      borderBottom: `1px solid ${colors.border}`, 
      padding: "16px 24px", 
      display: "flex", 
      alignItems: "center", 
      gap: "16px", 
      position: "sticky", 
      top: 0, 
      zIndex: 10 
    },
    backBtn: { 
      background: "none", 
      border: "none", 
      cursor: "pointer", 
      color: colors.textSecondary, 
      display: "flex", 
      alignItems: "center", 
      gap: "8px", 
      fontSize: "14px", 
      padding: "8px 12px", 
      borderRadius: "8px",
      transition: "all 0.2s"
    },
    headerTitle: { fontSize: "20px", fontWeight: 700, color: colors.textPrimary, margin: 0 },
    
    tabBar: {
      background: colors.surface,
      borderBottom: `1px solid ${colors.border}`,
      padding: "0 24px",
      display: "flex",
      gap: "4px",
      overflowX: "auto",
      overflowY: "hidden",
      whiteSpace: "nowrap",
      scrollbarWidth: "thin",
      position: "sticky",
      top: "72px",
      zIndex: 9,
    },
    tab: (isActive) => ({
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "12px 20px",
      background: "none",
      border: "none",
      borderBottom: isActive ? `2px solid ${colors.primary}` : "2px solid transparent",
      color: isActive ? colors.primary : colors.textSecondary,
      fontSize: "13px",
      fontWeight: isActive ? 600 : 500,
      cursor: "pointer",
      transition: "all 0.2s ease",
      whiteSpace: "nowrap",
    }),
    
    content: { padding: "24px", maxWidth: "1200px", margin: "0 auto" },
    
    profileCard: { 
      background: colors.surface, 
      border: `1px solid ${colors.border}`, 
      borderRadius: "20px", 
      padding: "24px", 
      marginBottom: "24px", 
      display: "flex", 
      alignItems: "center", 
      gap: "24px", 
      flexWrap: "wrap" 
    },
    profileInfo: { flex: 1 },
    profileName: { fontSize: "24px", fontWeight: 700, color: colors.textPrimary, marginBottom: "8px" },
    profileBadges: { display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "16px" },
    profileContact: { display: "flex", gap: "24px", flexWrap: "wrap", fontSize: "14px", color: colors.textSecondary },
    contactItem: { display: "flex", alignItems: "center", gap: "8px" },
    
    statsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "24px" },
    statCard: { 
      background: colors.surface, 
      border: `1px solid ${colors.border}`, 
      borderRadius: "16px", 
      padding: "20px", 
      textAlign: "center",
      transition: "all 0.2s"
    },
    statValue: { fontSize: "28px", fontWeight: 700, color: colors.textPrimary, marginBottom: "4px" },
    statLabel: { fontSize: "12px", color: colors.textMuted, textTransform: "uppercase", letterSpacing: "0.5px" },
    
    imagesSection: {
      background: colors.surface,
      border: `1px solid ${colors.border}`,
      borderRadius: "20px",
      marginBottom: "24px",
      overflow: "hidden",
    },
    sectionHeader: { 
      padding: "16px 24px", 
      borderBottom: `1px solid ${colors.border}`, 
      display: "flex", 
      alignItems: "center", 
      gap: "12px",
      background: colors.surfaceLighter
    },
    sectionTitle: { fontSize: "16px", fontWeight: 600, color: colors.textPrimary, margin: 0 },
    sectionContent: { padding: "24px" },
    imagesGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))", gap: "16px" },
    imageCard: { 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      gap: "8px", 
      padding: "12px",
      background: colors.surfaceLighter,
      borderRadius: "12px",
      border: `1px solid ${colors.borderLight}`
    },
    imageLabel: { fontSize: "11px", fontWeight: 500, color: colors.textMuted, textAlign: "center" },
    
    infoSection: { 
      background: colors.surface, 
      border: `1px solid ${colors.border}`, 
      borderRadius: "20px", 
      marginBottom: "24px", 
      overflow: "hidden" 
    },
    infoGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" },
    infoRow: { display: "flex", alignItems: "flex-start", gap: "12px" },
    infoLabel: { width: "140px", fontSize: "13px", fontWeight: 500, color: colors.textMuted, flexShrink: 0 },
    infoValue: { fontSize: "13px", color: colors.textPrimary, wordBreak: "break-word", flex: 1 },
    
    verificationItem: { 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "space-between", 
      padding: "12px 0", 
      borderBottom: `1px solid ${colors.borderLight}` 
    },
    verificationLabel: { fontSize: "13px", fontWeight: 500, color: colors.textSecondary },
    verificationStatus: (isVerified) => ({ 
      fontSize: "13px", 
      fontWeight: 600, 
      color: isVerified ? colors.success : colors.warning 
    }),
  };

  const isVerified = (value) => value === "1";

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        button:hover { transform: translateY(-1px); opacity: 0.9; }
        button:active { transform: translateY(0); }
        ::-webkit-scrollbar { width: 6px; height: 6px; }
        ::-webkit-scrollbar-track { background: ${isDark ? "#1a2035" : "#e2e8f0"}; border-radius: 3px; }
        ::-webkit-scrollbar-thumb { background: ${isDark ? "#4a4f6e" : "#94a3b8"}; border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: ${isDark ? "#6b7280" : "#64748b"}; }
        .tab-bar::-webkit-scrollbar { height: 3px; }
      `}</style>

      {/* Header */}
      <div style={styles.header}>
        <button 
          style={styles.backBtn} 
          onClick={() => navigate(-1)}
          onMouseEnter={(e) => e.currentTarget.style.background = colors.surfaceLighter}
          onMouseLeave={(e) => e.currentTarget.style.background = "none"}
        >
          <BackIcon /> Back
        </button>
        <h2 style={styles.headerTitle}>Driver Details</h2>
      </div>

      {/* Fixed Tab Bar */}
      <div style={styles.tabBar} className="tab-bar">
        {tabs.map(tab => (
          <button
            key={tab.id}
            style={styles.tab(activeTab === tab.id)}
            onClick={() => {
              if (tab.id === "overview" || tab.id === "delivery_history" || tab.id === "documents") {
                setActiveTab(tab.id);
              } else {
                tab.onClick();
              }
            }}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <div style={styles.content}>
        {/* Profile Section - Always Visible */}
        <div style={styles.profileCard}>
          <DriverAvatar 
            picName={driver.pic} 
            name={displayName} 
            theme={isDark ? 'dark' : 'light'} 
            size="80px"
          />
          <div style={styles.profileInfo}>
            <h1 style={styles.profileName}>{displayName}</h1>
            <div style={styles.profileBadges}>
              <StatusBadge status={driver.status} colors={colors} />
              <ReadyBadge is_ready={driver.is_ready} colors={colors} />
              <OnOffBadge open_status={driver.open_status} colors={colors} />
            </div>
            <div style={styles.profileContact}>
              <span style={styles.contactItem}><PhoneIcon /> {displayContact}</span>
              <span style={styles.contactItem}><EmailIcon /> {displayEmail}</span>
              <span style={styles.contactItem}><IdCardIcon /> ID: {driver.id}</span>
              <span style={styles.contactItem}><CalendarIcon /> Joined: {joinedDate}</span>
            </div>
          </div>
        </div>

        {/* Delivery History Tab */}
        {activeTab === "delivery_history" && (
          <DeliveryHistoryTable driverId={driver.id} isDark={isDark} />
        )}

        {/* Documents Tab - Contains Verification Status + Document Images */}
        {activeTab === "documents" && (
          <>
            {/* Verification Status */}
            <div style={styles.infoSection}>
              <div style={styles.sectionHeader}>
                <CheckCircleIcon />
                <h3 style={styles.sectionTitle}>Verification Status</h3>
              </div>
              <div style={styles.sectionContent}>
                <VerificationStatusCard 
                  label="Personal Information" 
                  isVerified={isVerified(driver.is_verify_personalinfo)}
                  remarks={driver.remarks_personalinfo}
                  colors={colors}
                />
                <VerificationStatusCard 
                  label="Documents" 
                  isVerified={isVerified(driver.is_verify_docinfo)}
                  remarks={driver.remarks_docinfo}
                  colors={colors}
                />
                <VerificationStatusCard 
                  label="Vehicle" 
                  isVerified={isVerified(driver.is_verify_vehicle)}
                  remarks={driver.remarks_vehicle}
                  colors={colors}
                />
                <VerificationStatusCard 
                  label="Bank Information" 
                  isVerified={isVerified(driver.is_verify_bankinfo)}
                  remarks={driver.remarks_bankinfo}
                  colors={colors}
                />
                <VerificationStatusCard 
                  label="Emergency Contact" 
                  isVerified={isVerified(driver.is_verify_emergency)}
                  remarks={driver.remarks_emergency}
                  colors={colors}
                />
              </div>
            </div>

            {/* Driver Documents & Images */}
            {documentImages.length > 0 && (
              <div style={styles.imagesSection}>
                <div style={styles.sectionHeader}>
                  <ImageIcon />
                  <h3 style={styles.sectionTitle}>Driver Documents & Images</h3>
                </div>
                <div style={styles.sectionContent}>
                  <div style={styles.imagesGrid}>
                    {documentImages.map((img, idx) => (
                      <div key={idx} style={styles.imageCard}>
                        <DriverDocumentImage 
                          picName={img.value} 
                          label={img.label} 
                          theme={isDark ? 'dark' : 'light'} 
                          size="80px"
                        />
                        <span style={styles.imageLabel}>{img.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Verify Actions */}
            <div style={{
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
              marginTop: "16px"
            }}>
              <button
                onClick={() => {
                  navigate("/Dashboard/VerifyDriverDocuments", { state: { driver } });
                }}
                style={{
                  padding: "10px 24px",
                  background: colors.primary,
                  border: "none",
                  borderRadius: "8px",
                  color: "#fff",
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: "13px",
                  transition: "all 0.2s"
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = "0.9"}
                onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
              >
                Verify Documents
              </button>
              <button
                onClick={handleEdit}
                style={{
                  padding: "10px 24px",
                  background: colors.surface,
                  border: `1px solid ${colors.border}`,
                  borderRadius: "8px",
                  color: colors.textPrimary,
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: "13px",
                  transition: "all 0.2s"
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = colors.surfaceLighter}
                onMouseLeave={(e) => e.currentTarget.style.background = colors.surface}
              >
                Edit Driver
              </button>
            </div>
          </>
        )}

        {/* Overview Tab Content */}
        {activeTab === "overview" && (
          <>
            {/* Stats Grid */}
            <div style={styles.statsGrid}>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{displayWallet}</div>
                <div style={styles.statLabel}>Wallet Balance</div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{displayCashInHand}</div>
                <div style={styles.statLabel}>Cash in Hand</div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{driver.totalDeliveries || 0}</div>
                <div style={styles.statLabel}>Total Deliveries</div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{driver.rating || 'N/A'}</div>
                <div style={styles.statLabel}>Rating</div>
              </div>
            </div>

            {/* Personal Information */}
            <div style={styles.infoSection}>
              <div style={styles.sectionHeader}>
                <IdCardIcon />
                <h3 style={styles.sectionTitle}>Personal Information</h3>
              </div>
              <div style={styles.sectionContent}>
                <div style={styles.infoGrid}>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Full Name</div>
                    <div style={styles.infoValue}>{displayName}</div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Contact Number</div>
                    <div style={styles.infoValue}>{displayContact}</div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Email</div>
                    <div style={styles.infoValue}>{displayEmail}</div>
                  </div>
                  {/* Password Field with Show/Hide */}
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Password</div>
                    <div style={styles.infoValue}>
                      <PasswordField password={driver.password} colors={colors} />
                    </div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Address</div>
                    <div style={styles.infoValue}>{driver.address || '—'}</div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>City / State</div>
                    <div style={styles.infoValue}>{driver.city || '—'}, {driver.state || '—'}</div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>PIN Code</div>
                    <div style={styles.infoValue}>{driver.postal || '—'}</div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Gender</div>
                    <div style={styles.infoValue}>{driver.gender || '—'}</div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Date of Birth</div>
                    <div style={styles.infoValue}>{driver.date_of_birth || '—'}</div>
                  </div>
                  <div style={styles.infoRow}>
                    <div style={styles.infoLabel}>Blood Group</div>
                    <div style={styles.infoValue}>{driver.blood_group || '—'}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bank Information */}
            {(driver.bank_name || driver.account_number || driver.ifsc) && (
              <div style={styles.infoSection}>
                <div style={styles.sectionHeader}>
                  <WalletIcon />
                  <h3 style={styles.sectionTitle}>Bank Information</h3>
                </div>
                <div style={styles.sectionContent}>
                  <div style={styles.infoGrid}>
                    <div style={styles.infoRow}>
                      <div style={styles.infoLabel}>Bank Name</div>
                      <div style={styles.infoValue}>{driver.bank_name || '—'}</div>
                    </div>
                    <div style={styles.infoRow}>
                      <div style={styles.infoLabel}>Branch</div>
                      <div style={styles.infoValue}>{driver.bank_branch || '—'}</div>
                    </div>
                    <div style={styles.infoRow}>
                      <div style={styles.infoLabel}>Account Holder</div>
                      <div style={styles.infoValue}>{driver.account_holder || '—'}</div>
                    </div>
                    <div style={styles.infoRow}>
                      <div style={styles.infoLabel}>Account Number</div>
                      <div style={styles.infoValue}>{driver.account_number || '—'}</div>
                    </div>
                    <div style={styles.infoRow}>
                      <div style={styles.infoLabel}>IFSC Code</div>
                      <div style={styles.infoValue}>{driver.ifsc || '—'}</div>
                    </div>
                    <div style={styles.infoRow}>
                      <div style={styles.infoLabel}>UPI ID</div>
                      <div style={styles.infoValue}>{driver.upi || '—'}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DriverDetails;